export const isProduction = import.meta.env.VITE_PRODUCTION === "true";

const appDomain = import.meta.env.VITE_APP_DOMAIN ?? "";
const landingDomain = import.meta.env.VITE_LANDING_DOMAIN ?? "";

export const dashboardUrl = `${appDomain}/dashboard`;
export const signupUrl = `${appDomain}/auth/jwt/register`;
export const landingUrl = `${landingDomain}/`;

export const HOST_API = import.meta.env.VITE_HOST_API;
export const ASSETS_API = import.meta.env.VITE_ASSETS_API;
export const MAPBOX_API = import.meta.env.VITE_MAPBOX_API;
export const GOOGLE_API_KEY = import.meta.env.GOOGLE_API_KEY
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? '';
